// gerekce.js — GEREKÇE: TEK KURAL + TEK PENCERE (21 Eki 2026, K7)
//
// 🔑 Serkan: tek gerekçe penceresi, ortak kural "en az 3"; tasarım A (yönetimin CHANGE REPORT penceresinin hâli: eksikken
//    kırmızı ipucu, yazınca "N characters" sayacı). 🔴 Önce üç pencere vardı — FTL `ReasonModal` (yalnız boş olmasın, altında
//    Türkçe not), yönetimin CHANGE REPORT'u (en az 3, sayaç), TRAINING'in `GerekcePenceresi` (en az 3, tek satır) — ve formların
//    içindeki ~15 gerekçe alanının yarısı "Ab"yi kaydediyor, öteki yarısı reddediyordu. Kural, ipucu ve pencere artık burada.
import React, { useState } from 'react';
import HarfliGiris from './HarfliGiris';
import { dugmeStili, zAlan } from './tasarim';
import { usePencereKapat, KapatX } from './pencereKapat';
import { vw } from '../yaziBoyutu';
import { GEREKCE_ASGARI, gerekceTamam, gerekceIpucuMetni } from './gerekceKurali';   // kural saf modülde


export { GEREKCE_ASGARI, gerekceTamam, gerekceIpucuMetni };

/** Gerekçe kutusunun altındaki satır — pencerede ve formların gerekçe alanlarında AYNI. */
export function GerekceIpucu({ metin, testid = null }) {
  return (
    <div data-testid={testid} style={{ fontSize:10, fontFamily:'var(--mono)', letterSpacing:.5, marginTop:6,
                                       color: gerekceTamam(metin) ? 'var(--t3)' : 'var(--red)' }}>
      {gerekceIpucuMetni(metin)}
    </div>
  );
}

const ETIKET = { fontSize:10, color:'var(--t2)', fontWeight:700, letterSpacing:1.5, textTransform:'uppercase',
                 fontFamily:'var(--mono)', display:'block', marginBottom:6 };
const KUTU = { background:'var(--input-bg)', border:'1px solid var(--border)', borderRadius:6, color:'var(--t1)', padding:'9px 11px',
               fontSize:13, fontFamily:'var(--mono)', width:'100%', boxSizing:'border-box', outline:'none',
               minHeight:80, resize:'vertical' };
const NOT = { fontSize:10, color:'var(--t3)', letterSpacing:.5, lineHeight:1.7, padding:'9px 12px', background:'var(--bg3)',
              borderLeft:'2px solid var(--border2)', fontFamily:'var(--mono)', marginBottom:12 };

/** TEK GEREKÇE PENCERESİ. `aciklamaTur`: 'silme' / 'uyari' kırmızı, 'degisiklik' nötr. `onayTur`: tasarim.js rolü ('silme'
 *  kırmızı, 'birincil' mavi). Onay düğmesi gerekçe yeterli olunca açılır; kaydederken kapanmaz (ESC / ✕ dahil). `zIndex`:
 *  çağıranın katmanı (FTL 60 · TRAINING 80 · yönetim 210 — kendi pencerelerinin üstünde). */
export function GerekcePenceresi({ baslik, aciklama = null, aciklamaTur = 'degisiklik', ek = null, etiket = 'Reason *',
                                   ornek = 'Mandatory: why is this being changed?', onayMetni, onayTur = 'birincil',
                                   testid = 'gerekce', metinTestid = null, zIndex = 60, onClose, onOnay }) {
  const [metin, setMetin] = useState('');
  const [mesgul, setMesgul] = useState(false);
  usePencereKapat(mesgul ? null : onClose);
  const tamam = gerekceTamam(metin);
  const kirmizi = aciklamaTur === 'silme' || aciklamaTur === 'uyari';
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex', alignItems:'center',
                  justifyContent:'center', zIndex }}>
      <div data-testid={`${testid}-pencere`}
           style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, width:520, maxWidth:vw(92) }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'11px 16px',
                      borderBottom:'1px solid var(--border)', background:'var(--bg3)' }}>
          <span style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'var(--accent)', textTransform:'uppercase',
                         fontFamily:'var(--mono)' }}>{baslik}</span>
          <KapatX onClose={onClose} disabled={mesgul} />
        </div>
        <div style={{ padding:16 }}>
          {aciklama && (
            <div data-testid={`${testid}-aciklama`}
                 style={{ ...NOT, ...(kirmizi ? { borderLeftColor:'var(--red)', color:'var(--red)' } : {}) }}>{aciklama}</div>
          )}
          {ek}
          <span style={{ ...ETIKET, marginTop: ek ? 14 : 0 }}>{etiket}</span>
          <HarfliGiris as="textarea" {...zAlan(KUTU, true, tamam)} data-testid={metinTestid || `${testid}-gerekce`}
                       value={metin} onChange={setMetin} placeholder={ornek} autoFocus />
          <GerekceIpucu metin={metin} testid={`${testid}-ipucu`} />
          <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:14 }}>
            <button type="button" style={dugmeStili('notr')} onClick={onClose} disabled={mesgul}>CANCEL</button>
            <button type="button" style={dugmeStili(onayTur, { devreDisi: !tamam || mesgul })} disabled={!tamam || mesgul}
                    data-testid={`${testid}-onay`}
                    onClick={async () => { setMesgul(true); try { await onOnay(metin.trim()); } finally { setMesgul(false); } }}>
              {mesgul ? 'SAVING...' : onayMetni}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
